import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {parseUrlQuery}  from "@Common/utils/parse-url-query";

import {AccountCreditCardsPanel} from "../../../../common/credit-cards-panel/credit-cards-panel";
import {UserAssetsLayout}        from "../common/layout/user-assets-layout";

export const AccountAdminCreditCardsRoute = () => cs(
    ({}, next) => UserAssetsLayout({activeTab: "admin-credit-cards", next}),
    ["agentId", ({}, next) => next(parseUrlQuery(window.location.search)?.agent)],

    consumeContext("apis"),
    ({apis, agentId}) => AccountCreditCardsPanel({
        apis: {
            getList: () => apis.next.creditCard.getCreditCards({idAgent: agentId}),
            addUpdate: (card) => apis.next.creditCard.addUpdate(card, agentId),
            deleteCard: (cardToken) => apis.next.creditCard.deleteCard(cardToken, agentId),
            makeCardDefault: (cardToken) =>  apis.next.creditCard.makeCardDefault(cardToken),
        },
    }),
);
